import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=96e19fd0&scoped=true&lang=html"
import script from "./ProductVariations.vue?vue&type=script&lang=js"
export * from "./ProductVariations.vue?vue&type=script&lang=js"
import style0 from "./ProductVariations.vue?vue&type=style&index=0&id=96e19fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e19fd0",
  null
  
)

export default component.exports